import { render } from "./detailPolicy.vue?vue&type=template&id=c6acbe98&scoped=true"
import script from "./detailPolicy.vue?vue&type=script&lang=js"
export * from "./detailPolicy.vue?vue&type=script&lang=js"

import "./detailPolicy.vue?vue&type=style&index=0&id=c6acbe98&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6acbe98"]])

export default __exports__